import React from 'react'

import Modal from 'react-bootstrap/Modal'
import {Button} from "react-bootstrap";

import { IoLayersOutline } from "react-icons/io5";
import { PiStorefront } from "react-icons/pi";

import AsyncSelect from "../common/AsyncSelect"

import Backend from '../../../utils/Backend'
import General from '../../../utils/General'
import Notify from '../../../utils/Notify'

export default class TerminalAssignmentModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props),
      loading: false,
      error: null,
      selectedCompany: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props) {
    return {
      ...props,
      data: {
        store: null,
        terminals: props.selectedTerminals,
      },
      modalStep: 1,
      reassignOption: null
    }
  }

  _assignTerminals = () => {
    let {
      data
    } = this.state

    this.setState({
      loading: true
    })

    Backend.assignTerminals(data).then(response => {
      Notify.success("Terminals Reassigned Successfully")
      this.props.onSuccess()
    }).catch(error => {
      this.setState({
        loading: false
      })
      Notify.error(error.message)
    })
  }

  _handleModalNext = () => {
    const { modalStep, reassignOption } = this.state;
    if (modalStep === 1) {
      this.setState({ modalStep: 2 });
    } else if (modalStep === 2) {
      if (reassignOption === "inventory") {
        this.closeModal();
        Notify.success("Terminal(s) reassigned to Inventory successfully");
      } else if (reassignOption === "store") {
        this.setState({ modalStep: 3 });
      }
    }
  };

  _handleModalBack = () => {
    const { modalStep } = this.state;
    if (modalStep === 2) this.setState({ modalStep: 1 });
    else if (modalStep === 3) this.setState({ modalStep: 2 });
  };

  _renderModalContent() {
    let {
      data,
      loading,
      modalStep,
      selectedCompany,
      reassignOption
    } = this.state

    if (modalStep === 1) {
      return (
        <>
          <Modal.Header>
            <Modal.Title>Terminal Reassignment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              If your terminal(s) are currently boarded, please be aware that all
              reassignments will only be effective after your terminal(s)
              synchronize with the platform
            </div>
          </Modal.Body>
          <Modal.Footer
            className={"d-flex justify-content-end"}
          >
            <Button variant="secondary" onClick={this.props.onHide}>
              Close
            </Button>
            <Button variant="primary" onClick={this._handleModalNext}>
              Got it
            </Button>
          </Modal.Footer>
        </>
      );
    }else if (modalStep === 2) {
      return (
        <>
          <Modal.Header>
            <Modal.Title>What would you like to do?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="options">
              <div
                className={`option ${
                  reassignOption === "inventory" ? "active" : ""
                }`}
                onClick={() => this.setState({ reassignOption: "inventory" })}
              >
                <IoLayersOutline />
                <div className="txt">
                  <h6>Back to inventory</h6>
                  Your terminal(s) will be reassigned to inventory.
                </div>
              </div>
              <div
                className={`option ${reassignOption === "store" ? "active" : ""}`}
                onClick={() => this.setState({ reassignOption: "store" })}
              >
                <PiStorefront />
                <div className="txt">
                  <h6>To store</h6>
                  Terminals assigned to a store can be boarded and can then
                  process payments. Assign terminals to a store if they currently
                  or will soon process in-store payments.
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {reassignOption === "inventory" && (
              <Button
                variant="primary"
                disabled={loading}
                onClick={this._assignTerminals}
              >
                Confirm
              </Button>
            )}
            {reassignOption !== "inventory" && (
              <div className="buttons-grid">
                <Button variant="secondary" onClick={this._handleModalBack}>
                  Back
                </Button>
                <Button
                  variant="primary"
                  onClick={this._handleModalNext}
                  disabled={!reassignOption}
                >
                  Next
                </Button>
              </div>
            )}
          </Modal.Footer>
        </>
      );
    }else if (modalStep === 3) {
      return (
        <>
          <Modal.Header>
            <Modal.Title>Assign Terminal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group row mb-1">
              <label className="col-12 col-form-label">Company</label>
              <div className="col-12">
                <AsyncSelect
                  endpoint={window.Api.Companies}
                  className={"custom-async-select__container"}
                  classNamePrefix={"custom-async-select"}
                  placeholder={"Select Company"}
                  value={General.getSingleAsyncOption(selectedCompany)}
                  onSelected={(selectedCompany) => {
                    data.store = null;
                    this.setState({ data, selectedCompany });
                  }}
                  getOptions={(companies) => General.getAsyncOptions(companies)}
                />
              </div>
            </div>

            <div className="form-group row">
              <label className="col-12 col-form-label">Store</label>
              <div className="col-12">
                <AsyncSelect
                  endpoint={window.Api.Stores}
                  filter={`company_id=${selectedCompany?.id}`}
                  className={"custom-async-select__container"}
                  classNamePrefix={"custom-async-select"}
                  placeholder={"Select Store"}
                  disabled={!selectedCompany}
                  value={General.getSingleAsyncOption(data.store)}
                  onSelected={(selectedStore) => {
                    data.store = selectedStore;
                    this.setState({ data });
                  }}
                  getOptions={(stores) => General.getAsyncOptions(stores)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="buttons-grid">
              <Button variant="secondary" onClick={this._handleModalBack}>
                Back
              </Button>
              <Button
                variant="primary"
                onClick={this._assignTerminals}
                disabled={!data.store || loading}
              >
                Confirm
              </Button>
            </div>
          </Modal.Footer>
        </>
      );
    }
  }


  render() {
    let {
      show,
      modalStep,
    } = this.state

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        centered
        className={`reassign-modal step-${modalStep}`}
      >
        {this._renderModalContent()}
      </Modal>
    )
  }
}
